import axiosIns from '@/api/axios'


export const GET_BUSSINESS_UNIT = (args) => {
    return axiosIns.post(`/master-data/business-unit-new`, {
        type: 'COM'
    });
}
export const GET_BUSSINESS_UNIT_EMPLOYEE = (args) => {
    return axiosIns.post(`/master-data/business-unit-new/employee`, {
        type: 'COM'
    });
}


